export default __webpack_public_path__ + "static/media/front-end-skills-icon.43f4486e.svg";